import { SvgIcon, SvgIconProps } from "@mui/material";

const PlayIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 10 12" fill="none" width="10" height="12" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M0.666016 1.68338V10.3167C0.666016 10.975 1.39102 11.375 1.94935 11.0167L8.73268 6.70005C9.24935 6.37505 9.24935 5.62505 8.73268 5.29171L1.94935 0.983381C1.39102 0.625047 0.666016 1.02505 0.666016 1.68338Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default PlayIcon;
